module.exports = __webpack_public_path__ + "static/img/payment_link_button_img.2865aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment_link_button_img.png
// module id = oix/
// module chunks = 3